<div style="margin-left:0!important;">

    <mat-icon *ngIf="showWarning"
              [matTooltipShowDelay]="delay"
              [matTooltip]="warningMessage | translate "
              class="feedback-warning"
              matTooltipClass="mat-tooltip-cp no-margin"
              matTooltipPosition="above">warning</mat-icon>

    <mat-icon *ngIf="showError"
              [matTooltipShowDelay]="delay"
              [matTooltip]="errorMessage | translate"
              class="feedback-error"
              matTooltipClass="mat-tooltip-cp no-margin"
              matTooltipPosition="above">error</mat-icon>

    <div *ngIf="showSuccess"
         [matTooltipShowDelay]="delay"
         [matTooltip]="successMessage | translate"
         class="feedback-success"
         matTooltipClass="mat-tooltip-cp no-margin"
         matTooltipPosition="above"></div>
</div>
